var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "catalog-choice-label"
  }, [_vm.sellerName ? _c('div', {
    staticClass: "catalog-choice-label__seller d-flex align-center flex-wrap"
  }, [_c('span', {
    staticClass: "catalog-choice-label__seller-name font-weight-bold"
  }, [_vm._v(_vm._s(_vm.sellerName))]), _vm.sellerConnected ? _c('v-icon', {
    staticClass: "ml-1 catalog-choice-label__link-icon flex-shrink-0",
    attrs: {
      "small": "",
      "color": "primary"
    }
  }, [_vm._v(" mdi-link ")]) : _vm._e()], 1) : _vm._e(), _vm.catalogName ? _c('div', {
    staticClass: "catalog-choice-label__catalog",
    "class": {
      'catalog-choice-label__catalog--solo': !_vm.sellerName
    }
  }, [_vm._v(" " + _vm._s(_vm.catalogName) + " ")]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }